// src/utils/subscription.js
import { toMillis } from "./time";

export function getSubscriptionGate(userDoc) {
  const now = Date.now();

  const status = userDoc?.subscriptionStatus;
  const plan = userDoc?.plan;
  const isActive = userDoc?.isActive === true || userDoc?.status === 'active';

  // Support both root and nested (in case DB has mixed structure)
  const trialEndsAtMs =
    toMillis(userDoc?.trialEndsAt) ?? toMillis(userDoc?.trialConfig?.trialEndsAt);

  // Check BOTH subscriptionStatus AND plan field for trial
  const isTrial =
    status === "trialing" ||
    status === "trial_active" ||
    status === "trial_verified" ||
    plan === "trial" ||
    plan === "trial_verified";

  // Check BOTH subscriptionStatus AND plan field for paid
  const isPaid =
    status === "paid_active" ||
    status === "active" ||
    status === "subscribed" ||
    plan === "monthly" ||
    plan === "yearly";

  // Only consider trial expired if we have a valid end date and it is in the past
  const trialExpired =
    isTrial && typeof trialEndsAtMs === "number" && now >= trialEndsAtMs;

  const trialValid =
    isTrial && typeof trialEndsAtMs === "number" && now < trialEndsAtMs;

  // Decide final access
  // ✅ FIX: Paid subscriptions always get access, regardless of isActive flag
  // This prevents blocking paying customers due to missing isActive field
  const allowed = isPaid || (isActive && trialValid);

  return {
    allowed,
    // ✅ FIX: Check paid status FIRST, before isActive check
    // This prevents showing "inactive" for paying customers
    reason: isPaid
      ? "paid"
      : !isActive
        ? "inactive"
        : trialExpired
          ? "trial_expired"
          : trialValid
            ? "trial_active"
            : "unknown",
    trialEndsAtMs,
  };
}
